import React from "react";

function index() {
  return (
    <div>
      <h5>this is skincare</h5>
    </div>
  );
}

export default index;
